import stbAPIGateway from '../../../../services/stbAPIGateway';

export const postCsvUpload = async ({ rootGetters }, { clientSid, type, attachment }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const client = await stbApi.postHubCsvUpload(clientSid, type, attachment);
  return client;
};
